import React from 'react'

function AboutHeader() {
  return (
    <div className="heading heading-about">
      <div>
        <h2>#KnowUs</h2>
        <p>Read all case studies about our products!</p>
      </div>
    </div>
  );
}

export default AboutHeader